import { render, staticRenderFns } from "./Exclusao.vue?vue&type=template&id=0cad4966"
import script from "./Exclusao.vue?vue&type=script&setup=true&lang=js"
export * from "./Exclusao.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports